import React from 'react';
import { useParams } from 'react-router-dom';
import Theme404 from '../../layout/404';

import orderList from './list';
import orderView from './view';

export default function OrderIndex() {
  let { slug = 'list' } = useParams();

  let ActualPage: any;
  switch (slug) {
    case 'list':
      ActualPage = orderList;
      break;

    case 'view':
      ActualPage = orderView;
      break;

    default:
      ActualPage = Theme404;
      break;
  }

  return <>{<ActualPage />}</>;
}

